import { Component, OnInit } from '@angular/core';

import { TipoPoder } from '../../../../models/tipo-poder.model';
import { CatalogosService } from '../../../../services/catalogos.service';

@Component({
  templateUrl: './post-registro-contratos.component.html',
  styleUrls: ['./post-registro-contratos.component.css'],
})
export class PostRegistroContratosComponent implements OnInit {
  breadCrumbItems = [
    {
      label: 'Usuario ventanilla',
      routerLink: '/inicio',
    },
    {
      label: 'Contratos (Trámites Post-Registro)',
      routerLink: '/post-registro/contratos',
    },
  ];

  tipo: TipoPoder[];
  loading = false;
  

  constructor(private catalogosService: CatalogosService) {}

  ngOnInit(): void {
    this.loading = true;
    this.catalogosService.getTiposContratosPR().subscribe((tipos) => {
      this.loading = false;
      const array: any[] = [];
      tipos.map((p, key) => {
        array.push(p);
      });
      this.tipo = array;
    });
  }
}
